export const MEDIA_POST_KIND = 20;
